import { faFacebook, faInstagram, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import type { SupporterResponse } from "@/lib/microcms.server";

interface SupportersArticleProps {
  post: SupporterResponse;
}

export function SupportersArticle({ post }: SupportersArticleProps) {
  return (
    <article className={clsx("grid", "grid-cols-[1fr]", "gap-12", "sm:grid-cols-[0.6fr_1fr]")}>
      <header className={clsx("col-span-1", "flex", "flex-col", "items-center")}>
        <div className={clsx("relative", "w-full", "pt-[100%]")}>
          <div className={clsx("absolute", "inset-0")}>
            <picture>
              <source
                type="image/webp"
                srcSet={`
                  ${post.avatar.url}?fm=webp&fit=crop&crop=center,center&w=220 320w,
                  ${post.avatar.url}?fm=webp&fit=crop&crop=center,center&w=450 450w
                `}
              />
              <img
                className={clsx("block", "rounded-xl", "object-cover", "object-[top_center]")}
                sizes="100vw"
                srcSet={`
                  ${post.avatar.url}?fit=crop&crop=center,center&w=220 320w,
                  ${post.avatar.url}?fit=crop&crop=center,center&w=450 450w
                `}
                src={`${post.avatar.url}?fit=crop&crop=center,center&w=450`}
                alt={post.name}
              />
            </picture>
          </div>
        </div>
      </header>

      <div className={clsx("text-center", "whitespace-pre-wrap")}>
        <div className="space-y-5">
          <h2 className={clsx("text-xl", "leading-normal", "font-bold", "text-gray-900")}>{post.name}</h2>
          <p>{post.biography}</p>
          <hr />
        </div>

        <span className="spacer mt-8" />

        <div className={clsx("flex", "flex-col")}>
          {post.twitterURL && (
            <div className="min-w-0">
              <div className={clsx("flex", "items-center", "space-x-2")}>
                <div className="min-w-0">
                  <FontAwesomeIcon icon={faTwitter} className={clsx("block", "w-4", "h-4", "text-gray-400")} />
                </div>
                <div className="min-w-0">
                  <a
                    href={post.twitterURL}
                    className={clsx("text-sm", "leading-loose", "text-gray-700", "hover:underline", "focus:underline")}
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    X（エックス）
                  </a>
                </div>
              </div>
            </div>
          )}
          {post.facebookURL && (
            <div className="min-w-0">
              <div className={clsx("flex", "items-center", "space-x-2")}>
                <div className="min-w-0">
                  <FontAwesomeIcon icon={faFacebook} className={clsx("block", "w-4", "h-4", "text-gray-400")} />
                </div>
                <div className="min-w-0">
                  <a
                    href={post.facebookURL}
                    className={clsx("text-sm", "leading-loose", "text-gray-700", "hover:underline", "focus:underline")}
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    公式フェイスブック
                  </a>
                </div>
              </div>
            </div>
          )}
          {post.instagramURL && (
            <div className="min-w-0">
              <div className={clsx("flex", "items-center", "space-x-2")}>
                <div className="min-w-0">
                  <FontAwesomeIcon icon={faInstagram} className={clsx("block", "w-4", "h-4", "text-gray-400")} />
                </div>
                <div className="min-w-0">
                  <a
                    href={post.instagramURL}
                    className={clsx("text-sm", "leading-loose", "text-gray-700", "hover:underline", "focus:underline")}
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    公式インスタグラム
                  </a>
                </div>
              </div>
            </div>
          )}
          {post.linkURL && (
            <div className="min-w-0">
              <div className={clsx("flex", "items-center", "space-x-2")}>
                <div className="min-w-0">
                  <FontAwesomeIcon icon={faLink} className={clsx("block", "w-4", "h-4", "text-gray-400")} />
                </div>
                <div className="min-w-0">
                  <a
                    href={post.linkURL}
                    className={clsx("text-sm", "leading-loose", "text-gray-700", "hover:underline", "focus:underline")}
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    公式ホームページ・ウェブサイト
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </article>
  );
}
